import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { toast } from 'react-toastify';
import { forgotPassword } from '../api/authApi';

export default function ForgotPasswordDialog(props: any) {
    const { open, handleClose } = props;
    const [buttonName, setButtonName] = React.useState("Send");
    const sendingButtonName = "Sending...";

    const sendPasswordResetLink = async (email: string) => {
        let sent = false;
        let message = "Something went wrong while sending the password reset link. Please try again or contact support.";

        try {
            const response = await forgotPassword({ email });
            if (response.success) {
                message = "If an account with this email exists in our system, a password reset link has been sent.";
                sent = true;
            } else {
                sent = false;
            }
        } catch (error: any) {
            sent = false;
        }

        return { sent, message };
    };

    return (
        <React.Fragment>
            <Dialog
                className='forgot-password-dialog'
                open={open}
                onClose={handleClose}
                PaperProps={{
                    component: 'form',
                    className: 'forgot-password-form',
                    onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
                        event.preventDefault();
                        setButtonName(sendingButtonName);
                        const formData = new FormData(event.currentTarget);
                        const formJson = Object.fromEntries((formData as any).entries());
                        const email = formJson.email;
                        console.log(email);
                        let { sent, message } = await sendPasswordResetLink(email);

                        if (!sent) {
                            toast.error(message);
                        } else {
                            toast.success(message);
                            handleClose();
                        }
                        setButtonName("Send");
                    },
                }}
            >
                <DialogTitle>Forgot Password</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="name"
                        name="email"
                        label="Email Address"
                        type="email"
                        fullWidth
                        variant="standard"
                        placeholder='Enter your email address to receive a password reset link'
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button type="submit" disabled={buttonName === sendingButtonName}>{buttonName}</Button>
                </DialogActions>

            </Dialog>
        </React.Fragment>
    );
}